<template>
  <div class="myOrderDetail">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      fixed
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div class="myOrderDetail_content">
      <div class="myOrderDetail_content_top">
        <div class="myOrderDetail_content_top_wait">
          <div class="myOrderDetail_content_top_wait_top">
            <img
              :src="require('@/assets/images/setting/' + imgName + '.png')"
              v-if="imgName"
            />
            <p>{{ name }}</p>
          </div>
          <div
            class="myOrderDetail_content_top_wait_bot"
            v-if="title == '待付款'"
          >
            剩<span>{{ time }}</span
            >，订单自动关闭
          </div>
          <div class="myOrderDetail_content_top_wait_bot1" v-else>
            <div class="myOrderDetail_content_top_dec">{{ dec }}</div>
            <div
              :data-clipboard-text="orderDetail.expressNumber"
              class="myOrderDetail_expressNumber_copy"
              v-if="orderDetail.expressNumber"
            >
              复制
            </div>
          </div>
        </div>
      </div>
      <div
        class="myOrderDetail_content_address"
        v-if="orderDetail.isPost && orderDetail.postAddress"
      >
        <div class="myOrderDetail_content_address_top">
          <div class="myOrderDetail_content_address_top_left">
            <img src="@/assets/images/setting/place.png" />
            <p class="myOrderDetail_content_address_top_name">
              {{ orderDetail.recipientName }}
            </p>
            <p class="myOrderDetail_content_address_top_phone">
              {{ phoneType(orderDetail.recipientTel) }}
            </p>
          </div>
          <div
            class="myOrderDetail_content_address_top_right"
            v-if="title == '待付款'"
            @click="modify"
          >
            修改
          </div>
        </div>
        <p class="myOrderDetail_content_address_content">
          {{ orderDetail.postAddress }}
        </p>
        <img
          src="@/assets/images/setting/bottom.png"
          class="myOrderDetail_content_address_bottom"
        />
      </div>
      <div
        class="myOrderDetail_content_noAddress"
        v-if="
          orderDetail.isPost && !orderDetail.postAddress && title == '待付款'
        "
        @click="goAdress"
      >
        <div class="myOrderDetail_content_noAddress_cont">
          <div class="myOrderDetail_content_noAddress_cont_left">
            <img src="@/assets/images/setting/place.png" />
            <div>请填写收货地址</div>
          </div>
          <img
            src="@/assets/images/setting/right.png"
            class="myOrderDetail_content_noAddress_cont_right"
          />
        </div>
        <img
          src="@/assets/images/setting/bottom.png"
          class="myOrderDetail_content_address_bottom"
        />
      </div>

      <div class="myOrderDetail_content_bot">
        <p class="myOrderDetail_content_bot_top">订单详情</p>
        <div class="myOrderDetail_content_bot_cen">
          <img
            :src="orderDetail.coverMaterialUrl"
            class="myOrderDetail_content_bot_cen_img"
          />
          <div class="myOrderDetail_content_bot_cen_rig">
            <div class="myOrderDetail_content_bot_cen_rig_title">
              {{ orderDetail.productName }}
            </div>
            <div
              class="myOrderDetail_content_bot_cen_rig_biaoqian"
              v-if="orderDetail.labels && orderDetail.labels.length > 0"
            >
              {{ orderDetail.labels[0].label }}
            </div>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay" v-if="orderDetail.isPost">
          <p>赠送：</p>
          <div class="myOrderDetail_content_bot_pay_way">
            <p>配套课程资料</p>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay" v-if="title == '已购买'">
          <p>支付方式：</p>
          <div class="myOrderDetail_content_bot_pay_way">
            <img :src="payPic" />
            <p>{{ orderDetail.payTypeName == "微信" ? "微信" : "支付宝" }}</p>
          </div>
        </div>
        <div class="myOrderDetail_content_bot_pay">
          <p>实际付款：</p>
          <div class="myOrderDetail_content_bot_pay_money">
            <span>¥</span
            >{{
              orderDetail.originalPrice &&
              orderDetail.originalPrice.toString().indexOf(".") > -1
                ? orderDetail.originalPrice.toString().split(".")[0]
                : orderDetail.originalPrice
            }}<span
              v-if="
                orderDetail.originalPrice &&
                orderDetail.originalPrice.toString().indexOf('.') > -1 &&
                orderDetail.originalPrice.toString().split('.')[1]
              "
              >.{{ orderDetail.originalPrice.toString().split(".")[1] }}</span
            >
          </div>
        </div>
      </div>
      <div class="myOrderDetail_content_order">
        <div class="myOrderDetail_content_order_num">
          <p>订单编号：</p>
          <p class="myOrderDetail_content_order_num_right">
            {{ orderDetail.id }}
          </p>
          <div
            :data-clipboard-text="orderDetail.id"
            class="myOrderDetail_content_order_num_copy"
          >
            复制
          </div>
        </div>
        <div class="myOrderDetail_content_order_time">
          <p>
            下单时间：<span>{{ orderDetail.createTime }}</span>
          </p>
        </div>
        <div class="myOrderDetail_content_order_time" v-if="title == '已购买'">
          <p>
            支付时间：<span>{{ orderDetail.payTime }}</span>
          </p>
        </div>
      </div>
      <div class="myOrderDetail_content_fix" v-if="title == '待付款'">
        <div class="myOrderDetail_content_fix_leftBt" @click="cancle">
          取消订单
        </div>
        <div class="myOrderDetail_content_fix_rightBt" @click="goPay">
          ￥{{ orderDetail.originalPrice }}去支付
        </div>
      </div>
      <div class="myOrderDetail_content_fix" v-if="title == '已购买'">
        <div class="myOrderDetail_content_fix_leftBt" @click="contact">
          联系我们
        </div>
      </div>
    </div>
    <van-popup
      v-model="popShow"
      round
      position="bottom"
      closeable
      :style="{ height: '57%' }"
    >
      <div class="popBox">
        <div class="popBox_price">
          <span>¥</span>
          {{
            orderDetail.originalPrice &&
            orderDetail.originalPrice.toString().indexOf(".") > -1
              ? orderDetail.originalPrice.toString().split(".")[0]
              : orderDetail.originalPrice
          }}
          <span
            v-if="
              orderDetail.originalPrice &&
              orderDetail.originalPrice.toString().indexOf('.') > -1 &&
              orderDetail.originalPrice.toString().split('.')[1]
            "
            >.{{ orderDetail.originalPrice.toString().split(".")[1] }}</span
          >
        </div>
        <div class="popBox_title">支付方式</div>
        <div class="popBox_payStyle">
          <van-radio-group v-model="radio">
            <div
              class="popBox_payStyle_wei"
              v-for="(item, index) in payTypeList"
            >
              <div class="popBox_payStyle_wei_left">
                <img
                  src="@/assets/images/setting/weixin.png"
                  v-if="item.method_name == '微信支付'"
                />
                <img src="@/assets/images/setting/zhifu.png" v-else />
                <p>{{ item.method_name }}</p>
              </div>
              <div class="popBox_payStyle_wei_right">
                <van-radio :name="JSON.stringify(index)"></van-radio>
              </div>
            </div>
          </van-radio-group>
        </div>
        <van-button
          class="popBox_button"
          @click="pay"
          :loading="btnLoading"
          loading-text="支付唤起中"
        >
          立即支付￥{{ orderDetail.originalPrice }}
        </van-button>
      </div>
    </van-popup>
    <div id="zhifuB"></div>
    <dialog-common
      :infoShow="show"
      :infoMsg="infoMsg"
      :sureMsg="sureMsg"
      @goback="close"
      @next="next"
    ></dialog-common>
    <contact-us
      :contactShow="contactShow"
      @close="handleClose"
      :imgList="imgList"
      :phone="phone"
    ></contact-us>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import dialogCommon from "@/components/dialogCommon";
import { decryptBy, encryptBy } from "@/assets/js/encryption";
import { setOpenId, registerWxConfig } from "@/weixinConfig";
import {
  _orderDetail,
  _cancelOrder,
  _paymentMethodList,
  _payOrder,
  _exsitPaidOrders,
} from "../../api/setting";
import wx from "weixin-js-sdk";
import { type } from "os";
import ContactUs from "./components/contact-us.vue";
export default {
  name: "myOrderDetail",
  data() {
    return {
      contactShow: false,
      title: "", //页面title
      time: "", //待付款订单失效时间
      orderDetail: {}, //订单详情
      imgName: "", //订单状态图片
      name: "", //订单状态
      dec: "", //订单除了待付款状态，其他的状态描述
      payPic: "", //支付方式图片
      timer: null, //倒计时计时器
      id: "", //订单id
      popShow: false, //支付弹窗标识
      radio: "0", //支付方式选择标识
      payTypeList: [], //支付方式列表
      show: false,
      infoMsg: "是否要取消该订单？",
      sureMsg: "确定",
      imgList: [
        // "@/assets/images/setting/wx.jpg",
        // "@/assets/images/setting/wx.jpg",
      ],
      phone: "",
      btnLoading: false,
    };
  },
  components: {
    dialogCommon,
    ContactUs,
  },
  created() {
    if (!sessionStorage.getItem("openid")) {
      registerWxConfig();
    }
    this.id = this.$route.query.id;
    this.getOrderDetail();
    // this.orderDetail = JSON.parse(localStorage.getItem('orderDetail'));
  },
  filters: {
    //过滤待付款剩余时间
    filter_time(val) {
      let time = "";
      if (Number(val) < 60) {
        time = "00:" + val;
      } else {
        if (Number(val) % 60 == 0) {
          if (Number(val) / 60 > 9) {
            time = Number(val) / 60 + ":00";
          } else {
            time = "0" + Number(val) / 60 + ":00";
          }
        } else {
          if (parseInt(Number(val) / 60) > 9) {
            time =
              String(parseInt(Number(val) / 60)) +
              ":" +
              String(Number(val) % 60);
          } else {
            time =
              "0" +
              String(parseInt(Number(val) / 60)) +
              ":" +
              String(Number(val) % 60);
          }
        }
      }
      return time;
    },
  },
  mounted() {
    let clipborad = new Clipboard(".myOrderDetail_content_order_num_copy");
    clipborad.on("success", (e) => {
      this.$toast("复制成功");
      clipborad.destroy();
    });

    let a = new Clipboard(".myOrderDetail_expressNumber_copy");
    a.on("success", (e) => {
      console.log("eee", e);
      this.$toast("复制成功");
      a.destroy();
    });
  },
  methods: {
    handleClose() {
      this.contactShow = false;
    },
    // 返回
    onClickLeft() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("myOrder");
        this.$router.push({
          path: "/myOrder",
          query: { sourceType: 1 },
        });
      } else {
        this.$router.go(-1);
        clearInterval(this.timer);
      }
    },
    phoneType(val) {
      if (val) {
        if (val.length === 11) {
          return val;
        } else {
          return decryptBy(val);
        }
      }
    },
    close() {
      this.show = false;
    },
    next() {
      this.cancelOrder(this.id);
    },
    //点击取消订单
    cancle() {
      this.show = true;
    },
    //取消订单接口
    cancelOrder(data) {
      this.loading = true;
      _cancelOrder({
        orderId: data,
      })
        .then((res) => {
          if (res && res.code == 200) {
            this.loading = false;
            this.onClickLeft();
          } else {
            Toast(res.message);
            this.loading = false;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //跳转到添加地址
    goAdress() {
      this.$router.push({
        path: "/addAdress",
      });
    },
    //点击去付款弹窗支付方式
    goPay() {
      // if (!sessionStorage.getItem("openid")) {
      //   setOpenId("1");
      // }
      let params = {
        productId: this.orderDetail.productId,
      };
      _exsitPaidOrders(params).then((res) => {
        if (res.data) {
          this.$toast("与已购买课程冲突，无法购买");
        } else {
          this.getPaymentMethodList();
        }
      });
    },
    // 联系我们弹框
    contact() {
      this.contactShow = true;
    },
    //支付
    pay() {
      this.btnLoading = true;
      localStorage.setItem("orderDetail", this.orderDetail.id);
      if (this.radio == "0") {
        registerWxConfig();
        //radio为 0==微信   1==支付宝
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 1,
          openid,
          order_price: this.orderDetail.originalPrice,
          order_sn: this.orderDetail.id,
          system_id: 1,
        };
        _payOrder(params)
          .then((res) => {
            if (res.code == 200) {
              res.data = JSON.parse(res.data);
              wx.chooseWXPay({
                timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                package: res.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                paySign: res.data.paySign, // 支付签名
                success: function (res) {
                  console.log("支付成功了", res);
                  // 支付成功后的回调函数
                  window.location.href = "/#/paymentCallbackJump";
                },
                fail: function (error) {
                  console.log("error", error);
                  window.location.href = "/#/paymentCallbackJump";
                },
              });
            } else {
              this.$toast(res.message);
            }
            this.btnLoading = false;
          })
          .catch((res) => {
            this.$toast(res.message);
            this.btnLoading = false;
          });
      } else {
        const openid = sessionStorage.getItem("openid");
        let params = {
          client_type: "WAP",
          method_id: 2,
          openid,
          order_price: this.orderDetail.originalPrice,
          order_sn: this.orderDetail.id,
          system_id: 2,
        };
        _payOrder(params)
          .then((res) => {
            if (res.code == 200) {
              const div = document.getElementById("zhifuB");
              div.innerHTML = res.data;
              div.getElementsByTagName("form")[0].submit();
            } else {
              this.$toast(res.message);
            }
            this.btnLoading = false;
          })
          .finally((res) => {
            this.$toast(res.message);
            this.btnLoading = false;
          });
      }
    },
    //修改地址
    modify() {
      this.$router.push({
        path: "/adressList",
        query: {
          orderId: this.orderDetail.id,
          postAddressId: this.orderDetail.postAddressId,
        },
      });
    },
    // 获取订单详情
    getOrderDetail() {
      _orderDetail({
        orderId: this.id,
      }).then((res) => {
        if (res && res.code == 200) {
          this.orderDetail = res.data;
          this.title =
            this.orderDetail.orderState == 0
              ? "待付款"
              : this.orderDetail.orderState == 1
              ? "已购买"
              : "已取消";
          this.time = this.orderDetail.remainingTime;
          this.imgName =
            this.orderDetail.orderState == 0
              ? "wait"
              : this.orderDetail.orderState == 1 && !this.orderDetail.isPost
              ? "buy"
              : this.orderDetail.orderState == 1 &&
                (!this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber == "")
              ? "buy"
              : this.orderDetail.orderState == 1 &&
                (this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber != "")
              ? "transport"
              : "cancel";
          this.name =
            this.orderDetail.orderState == 0
              ? "等待付款"
              : this.orderDetail.orderState == 1 && !this.orderDetail.isPost
              ? "已购买"
              : this.orderDetail.orderState == 1 &&
                (!this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber == "")
              ? "买家已付款"
              : this.orderDetail.orderState == 1 &&
                (this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber != "")
              ? "已发货"
              : "已取消";
          this.dec =
            this.orderDetail.orderState == 1 && !this.orderDetail.isPost
              ? "订单已完成"
              : this.orderDetail.orderState == 1 &&
                (!this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber == "")
              ? "您的配套资料正在备货请耐心等待…"
              : this.orderDetail.orderState == 1 &&
                (this.orderDetail.expressNumber ||
                  this.orderDetail.expressNumber != "")
              ? `快递单号：${this.orderDetail.expressNumber}`
              : this.orderDetail.orderState == 0
              ? ""
              : "订单已取消";
          this.payPic =
            this.orderDetail.payTypeName == "微信"
              ? require("@/assets/images/setting/wei.png")
              : require("@/assets/images/setting/zhi.png");
          if (this.time != 0) {
            this.filterTime();
          }
          this.imgList = this.orderDetail.webChatUrl?.split(",") || [];
          this.phone = this.orderDetail.customerServiceTel;
        }
      });
    },
    // 获取支付方式
    getPaymentMethodList() {
      _paymentMethodList({
        clientType: "wap",
      }).then((res) => {
        if (res && res.statusCode == 200) {
          res.data = res.data.slice(0, 2);
          this.payTypeList = res.data;
          if (res.data && res.data.length > 0) {
            //调起选择支付模式弹窗
            this.popShow = true;
          }
        }
      });
    },
    // 倒计时
    countDown() {
      let timeArr = this.time.split(":");
      let minute = Number(timeArr[0]); // 分
      let second = Number(timeArr[1]); // 秒
      this.timer = setInterval(() => {
        if (second == 0) {
          if (minute == 0) {
            setTimeout(() => {
              clearInterval(this.timer);
              this.getOrderDetail();
            }, 100);
          } else {
            minute -= 1;
            second = 60;
            second -= 1;
          }
        } else {
          second -= 1;
        }
        this.time =
          (minute < 10 ? "0" + minute : minute) +
          ":" +
          (second < 10 ? "0" + second : second);
      }, 1000);
    },
    //处理待付款剩余时间
    filterTime() {
      let time = "";
      let val = this.time;
      if (Number(val) < 60) {
        time = "00:" + val;
      } else {
        if (Number(val) % 60 == 0) {
          if (Number(val) / 60 > 9) {
            time = Number(val) / 60 + ":00";
          } else {
            time = "0" + Number(val) / 60 + ":00";
          }
        } else {
          if (parseInt(Number(val) / 60) > 9) {
            if (Number(val) % 60 > 9) {
              time =
                String(parseInt(Number(val) / 60)) +
                ":" +
                String(Number(val) % 60);
            } else {
              time =
                String(parseInt(Number(val) / 60)) +
                ":" +
                "0" +
                String(Number(val) % 60);
            }
          } else {
            if (Number(val) % 60 > 9) {
              time =
                "0" +
                String(parseInt(Number(val) / 60)) +
                ":" +
                String(Number(val) % 60);
            } else {
              time =
                "0" +
                String(parseInt(Number(val) / 60)) +
                ":" +
                "0" +
                String(Number(val) % 60);
            }
          }
        }
      }
      this.time = time;
      this.countDown();
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
.myOrderDetail {
  height: 100%;
  background: #f5f7fa;
  position: relative;
  .myOrderDetail_content {
    padding-top: 48px;
  }
  .myOrderDetail_content_top {
    width: 375px;
    height: 80px;
    background: linear-gradient(139deg, #17e1eb 0%, #0197ec 100%);
    .myOrderDetail_content_top_wait {
      margin-left: 40px;
      .myOrderDetail_content_top_wait_top {
        display: flex;

        img {
          width: 22px;
          height: 22px;
          margin-right: 8px;
          margin-top: 14px;
        }
        p {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          margin-top: 12px;
        }
      }
      .myOrderDetail_content_top_wait_bot {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      .myOrderDetail_content_top_wait_bot1 {
        width: 95%;
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .myOrderDetail_content_top_dec {
          width: 90%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .myOrderDetail_expressNumber_copy {
          width: 40px;
          height: 20px;
          border-radius: 3px;
          color: #fff;
          text-align: center;
          font-size: 11px;
          line-height: 20px;
          background: rgba(245, 247, 250, 0.5);
        }
      }
    }
  }
  .myOrderDetail_content_noAddress {
    width: 375px;
    background: #ffffff;
    .myOrderDetail_content_noAddress_cont {
      display: flex;
      justify-content: space-between;
      padding: 38px 0;
      .myOrderDetail_content_noAddress_cont_left {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          height: 22px;
          margin-right: 10px;
          margin-left: 20px;
        }
        div {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #949c9d;
        }
      }
      .myOrderDetail_content_noAddress_cont_right {
        width: 22px;
        height: 22px;
        margin-right: 30px;
      }
    }
    .myOrderDetail_content_address_bottom {
      display: block;
      width: 100%;
    }
  }
  .myOrderDetail_content_address {
    width: 345px;
    background: #ffffff;
    border-radius: 4px;
    margin-left: 15px;
    .myOrderDetail_content_address_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
      padding-top: 10px;
      margin-left: 10px;
      .myOrderDetail_content_address_top_left {
        display: flex;
        align-items: center;
      }
      .myOrderDetail_content_address_top_right {
        width: 48px;
        height: 24px;
        background: rgba(14, 215, 225, 0.1);
        border-radius: 14px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #04a1eb;
        text-align: center;
        line-height: 24px;
        margin-right: 20px;
      }

      img {
        width: 22px;
      }
      .myOrderDetail_content_address_top_name {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e4344;
        margin-left: 8px;
        margin-right: 16px;
      }
      .myOrderDetail_content_address_top_phone {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e4344;
      }
    }
    .myOrderDetail_content_address_content {
      width: 294px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #626a6b;
      margin-left: 20px;
      margin-top: 8px;
      margin-bottom: 14px;
    }
    .myOrderDetail_content_address_bottom {
      display: block;
      width: 100%;
    }
  }
  .myOrderDetail_content_bot {
    padding: 12px 21px 15px 21px;
    width: 345px;
    background: #ffffff;
    border-radius: 4px;
    margin: 8px 0;
    margin-left: 15px;
    .myOrderDetail_content_bot_top {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2e4344;
      margin-bottom: 12px;
    }
    .myOrderDetail_content_bot_cen {
      display: flex;
      .myOrderDetail_content_bot_cen_img {
        width: 128px;
        height: 72px;
        border-radius: 4px;
        margin-right: 12px;
      }
      .myOrderDetail_content_bot_cen_rig {
        .myOrderDetail_content_bot_cen_rig_title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2e4344;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          margin-top: 4px;
        }
        .myOrderDetail_content_bot_cen_rig_biaoqian {
          display: inline-block;
          height: 22px;
          background: rgba(250, 125, 0, 0.1);
          border-radius: 11px;
          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fa7d00;
          line-height: 22px;
          text-align: center;
          padding: 0 8px;
          margin-top: 4px;
        }
      }
    }
    .myOrderDetail_content_bot_pay {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 14px;
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #141414;
      }
      .myOrderDetail_content_bot_pay_way {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          margin-right: 4px;
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2e4344;
        }
      }
      .myOrderDetail_content_bot_pay_money {
        font-size: 20px;
        font-family: DINAlternate-Bold, DINAlternate;
        font-weight: bold;
        color: #2e4344;
        span {
          font-size: 14px;
          font-family: DINAlternate-Bold, DINAlternate;
          font-weight: bold;
          color: #2e4344;
        }
      }
    }
  }
  .myOrderDetail_content_order {
    padding: 12px 21px 15px 21px;
    width: 345px;
    background: #ffffff;
    border-radius: 4px;
    margin: 8px 0;
    margin-left: 15px;
    .myOrderDetail_content_order_num {
      display: flex;
      justify-content: space-between;
      p {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
      .myOrderDetail_content_order_num_right {
        width: 195px;
        overflow: hidden; //超出隐藏
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //溢出显示省略号
        color: #2e4344;
        text-align: left;
      }
      div {
        width: 40px;
        height: 20px;
        background: #f5f7fa;
        border-radius: 3px;
        text-align: center;
        line-height: 20px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2e4344;
      }
    }
    .myOrderDetail_content_order_time {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-top: 12px;
    }
  }
  .myOrderDetail_content_fix {
    position: fixed;
    bottom: 0;
    width: 375px;
    height: 60px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    .myOrderDetail_content_fix_leftBt {
      width: 160px;
      height: 40px;
      background: #f3f6f7;
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #626a6b;
      text-align: center;
      line-height: 40px;
      margin-top: 10px;
    }
    .myOrderDetail_content_fix_rightBt {
      width: 160px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 20px;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-left: 14px;
      margin-top: 10px;
    }
  }
  .popBox_price {
    font-size: 32px;
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ee3721;
    text-align: center;
    margin-top: 19px;
    span {
      font-size: 24px;
    }
  }
  .popBox_title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #484848;
    margin-top: 20px;
    margin-left: 20px;
  }
  .popBox_payStyle_wei {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    .popBox_payStyle_wei_left {
      display: flex;
      align-items: center;
      img {
        width: 44px;
        height: 44px;
        margin-left: 30px;
        margin-right: 12px;
      }
      p {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #484848;
      }
    }
    .popBox_payStyle_wei_right {
      margin-right: 40px;
    }
  }
  .popBox_button {
    width: 300px;
    height: 44px;
    background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    margin-left: 37.5px;
    margin-top: 56px;
  }
}
</style>
